"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewerTranslations = exports.LocaleTranslations = void 0;
/**
 * Locale translation segment for form or system translations.
 */
var LocaleTranslations = /** @class */ (function () {
    function LocaleTranslations() {
        this.localeCode = '';
        this.localeName = '';
        this.translations = {};
    }
    return LocaleTranslations;
}());
exports.LocaleTranslations = LocaleTranslations;
/**
 * Response containing form and system translations for the form viewer.
 */
var ViewerTranslations = /** @class */ (function () {
    function ViewerTranslations() {
        this.form = new LocaleTranslations();
        this.system = new LocaleTranslations();
    }
    return ViewerTranslations;
}());
exports.ViewerTranslations = ViewerTranslations;
